import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";

(function () {
  ResourcesServicesController.$inject = ["$http", "API_URL", "$rootScope", "$timeout"];
  angular.module('userApp').controller('ResourcesServicesController', ResourcesServicesController);

  function ResourcesServicesController($http, API_URL, $rootScope, $timeout) {
    var res = this;
    res.api_url = API_URL;
    var throbber = $rootScope.throbber;

    res.init = function () {
      var user = $rootScope.userInfo,
          orgID = user.orgid,
          subscription = user.subscription;

      if (!!subscription) {
        res.servicesAllowed = subscription.services_allowed;
        res.resourcesAllowed = subscription.resources_allowed;
        res.onTrial = subscription.on_trial;
      }

      $http.get(API_URL + '/api/v1/resource').then(function (response) {
        response = response.data;

        if (response.success) {
          res.resourcesEnabled = 0;
          res.resources = response.resources.map(function (resource) {
            if (!resource.disabled) res.resourcesEnabled++;
            return _objectSpread({}, resource, {
              enabled: !resource.disabled
            });
          });
          $rootScope.safeApply();
        }
      }, function (response) {
        console.log(response);
      });
      $http.get(API_URL + '/api/v1/services/' + orgID).then(function (response) {
        response = response.data;

        if (response.success) {
          res.servicesEnabled = 0;
          res.services = response.services.map(function (service) {
            if (!service.disabled) res.servicesEnabled++;
            return _objectSpread({}, service, {
              enabled: !service.disabled
            });
          });
          $rootScope.safeApply();
        }
      }, function (response) {
        console.log(response);
      });
    }; // End init


    res.init();

    res.deleteResource = function (resourceID) {
      if (!confirm('Deleting this resource will delete all shifts associated with this resource. ' + 'Please confirm that you would like to delete this resource')) {
        return;
      }

      $http.delete(API_URL + '/api/v1/resource/' + resourceID).then(function (response) {
        res.init();
      }, function (error) {});
    };

    res.deleteService = function (serviceID) {
      if (!confirm("Deleting this service will delete all of this service's shifts and existing appointments and cannot be undone! Please confirm that you would like to delete this service")) {
        return;
      }

      $http.delete(API_URL + '/api/v1/service/' + serviceID).then(function (response) {
        res.init();
      }, function (error) {});
    };

    res.toggleService =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(index) {
        var service, _ref2, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                service = res.services[index];

                if (!(res.servicesEnabled === 1 && !service.enabled && !confirm('Are you sure you want to disable your last service? This will mean your schedule has no availability at all.'))) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", service.enabled = true);

              case 4:
                throbber.show();
                _context.next = 7;
                return $http.put("".concat(API_URL, "/api/v1/service/").concat(service._id), {
                  service: {
                    disabled: !service.enabled
                  }
                });

              case 7:
                _ref2 = _context.sent;
                data = _ref2.data;

                if (!data.toomanyservices) {
                  _context.next = 15;
                  break;
                }

                res.tooManyServices = true;
                res.init();
                $timeout(function () {
                  res.tooManyServices = false;
                }, 3000);
                throbber.hide();
                return _context.abrupt("return", $rootScope.safeApply());

              case 15:
                res.init();
                throbber.hide('Service updated');
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0.message);
                throbber.showError("Sorry but an error occurred with this request: ".concat(_context.t0.message));

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 19]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    res.toggleResource =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(index) {
        var resource, _ref4, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                resource = res.resources[index];

                if (!(res.resourcesEnabled === 1 && !resource.enabled && !confirm('Are you sure you want to disable your last resource? This may mean your schedule has no availability at all.'))) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", resource.enabled = true);

              case 4:
                throbber.show();
                _context2.next = 7;
                return $http.put("".concat(API_URL, "/api/v1/resource/").concat(resource._id), {
                  resource: {
                    disabled: !resource.enabled
                  }
                });

              case 7:
                _ref4 = _context2.sent;
                data = _ref4.data;

                if (!data.toomanyresources) {
                  _context2.next = 15;
                  break;
                }

                res.tooManyResources = true;
                res.init();
                $timeout(function () {
                  res.tooManyResources = false;
                }, 3000);
                throbber.hide();
                return _context2.abrupt("return", $rootScope.safeApply());

              case 15:
                res.init();
                throbber.hide('Resource updated');
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0.message);
                throbber.showError("Sorry but an error occurred with this request: ".concat(_context2.t0.message));

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 19]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  }
})();